module.exports = require("core-js/library/fn/symbol");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/core-js/symbol.js
// module id = 115
// module chunks = 0 1 2 3